var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCompactram(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 49,
    height: 55,
    viewBox: "0 0 49 55",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1288_1444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.26172 12.4304V41.1819L8.41126 42.9858L9.45578 42.5269L24.7017 51.2591V52.3163L27.8594 54.1249V25.3734L5.26172 12.4304Z",
    fill: "#C6C6C5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.42027 14.239L9.45663 13.5955L9.45648 21.75L13.2056 23.8957L12.8362 33.9719L9.45663 35.9062V42.5269L8.41211 42.9858L8.42027 14.239Z",
    fill: "#6F6F6E"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M25.6084 37.6553L26.8577 38.3823V35.4619L25.6084 34.739V37.6553Z",
    fill: "#575756"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M25.6084 33.6519L26.8577 34.3789V31.4585L25.6084 30.7356V33.6519Z",
    fill: "#575756"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M25.6084 41.617L26.8577 42.344V39.4236L25.6084 38.7007V41.617Z",
    fill: "#575756"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.833008 14.9654L25.5686 0.875L48.1663 13.818L23.4307 27.9084L0.833008 14.9654Z",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.7025 38.1807V42.3439L12.6227 35.4189L11.374 30.6372L24.7025 38.1807Z",
    fill: "#575756"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.7025 30.135V34.2983L12.6227 27.3732L11.374 22.5916L24.7025 30.135Z",
    fill: "#575756"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.45605 35.9063L12.3126 34.2715L24.7017 41.3674L24.702 44.6385L9.45605 35.9063Z",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.7025 34.1811V38.3444L12.6227 31.4194L11.374 26.6377L24.7025 34.1811Z",
    fill: "#575756"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.4187 34.2044L19.4903 34.2259L18.5831 30.7631L18.5107 30.7246L19.4187 34.2044Z",
    fill: "#6F6F6E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.4187 30.1846L19.4633 30.1506L18.5831 26.7434L18.5107 26.7048L19.4187 30.1846Z",
    fill: "#6F6F6E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.4654 38.3681L19.5237 38.4015L18.5831 34.7585L18.5107 34.72L19.4654 38.3681Z",
    fill: "#6F6F6E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.374 26.6348L12.3131 26.0974L24.7022 33.1934L24.7025 34.2666L11.374 26.6348Z",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.374 30.6373L12.3131 30.0999L24.7022 37.1959L24.7025 38.2691L11.374 30.6373Z",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.4307 30.0997V27.9083L0.833008 14.9653V17.1567L23.4307 30.0997Z",
    fill: "#C6C6C5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.47679 18.3443L24.0075 31.2391L23.4307 30.0997L0.833008 17.1567L1.47679 18.3443Z",
    fill: "#B1B1B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.4307 30.0997L24.0075 31.2391L27.8801 29.0226L27.8599 54.1249L48.1663 42.5694V13.8179L27.8599 25.3734L23.4307 27.9083V30.0997Z",
    fill: "#6F6F6E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1288_1444"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 47.3333,
    height: 53.25,
    fill: "white",
    transform: "translate(0.833008 0.875)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompactram);
export default __webpack_public_path__ + "static/media/compactram.2fb42cbdc546d0b7e0709dc8f799d646.svg";
export { ForwardRef as ReactComponent };